import React from 'react';
import { AiOutlineCamera } from 'react-icons/ai';
import './FloatingCameraButton.css';

const FloatingCameraButton = ({ onClick }) => {
  return (
    <button
      className="fcb-button"
      onClick={onClick}
      title="Capture & upload photos"
      aria-label="Capture photos"
    >
      <AiOutlineCamera size={24} />
    </button>
  );
};

export default FloatingCameraButton;
